// DynamoDB attribute value structure
export interface DynamoDBStringAttribute {
    S: string;
}

// Individual vocabulary item from DynamoDB
export interface DynamoDBVocabularyItem {
    Japanese_word: DynamoDBStringAttribute;
    English_word: DynamoDBStringAttribute;
}

// Full DynamoDB scan/query response
export interface DynamoDBVocabularyResponse {
    Count: number;
    Items: DynamoDBVocabularyItem[];
    ScannedCount: number;
}

// Simplified vocabulary item for application use
export interface VocabularyItem {
    japanese: string;
    english: string;
}

// Helper function to transform DynamoDB response to simplified format
export const transformVocabularyData = (
    dynamoResponse: DynamoDBVocabularyResponse,
): VocabularyItem[] =>
    dynamoResponse.Items.map((item) => ({
        japanese: item.Japanese_word.S,
        english: item.English_word.S,
    }));
